export const CONTENT_CATEGORIES = [
  { value: 'pessoal_familia', label: 'Pessoal/Família', color: 'bg-pink-100 text-pink-700', dot: 'bg-pink-500' },
  { value: 'institucional_mandato', label: 'Institucional', color: 'bg-blue-100 text-blue-700', dot: 'bg-blue-500' },
  { value: 'prestacao_contas', label: 'Prestação de Contas', color: 'bg-emerald-100 text-emerald-700', dot: 'bg-emerald-500' },
  { value: 'bandeira_politica', label: 'Bandeira Política', color: 'bg-indigo-100 text-indigo-700', dot: 'bg-indigo-500' },
  { value: 'ataque_crise', label: 'Ataque/Crise', color: 'bg-rose-100 text-rose-700', dot: 'bg-rose-500' },
  { value: 'valores_identidade', label: 'Valores/Identidade', color: 'bg-amber-100 text-amber-700', dot: 'bg-amber-500' },
  { value: 'agenda_rua', label: 'Agenda de Rua', color: 'bg-orange-100 text-orange-700', dot: 'bg-orange-500' },
  { value: 'comunitario', label: 'Comunitário', color: 'bg-teal-100 text-teal-700', dot: 'bg-teal-500' },
  { value: 'mobilizacao', label: 'Mobilização', color: 'bg-purple-100 text-purple-700', dot: 'bg-purple-500' },
  { value: 'religioso', label: 'Religioso', color: 'bg-violet-100 text-violet-700', dot: 'bg-violet-500' },
  { value: 'viral_entretenimento', label: 'Viral/Entretenimento', color: 'bg-fuchsia-100 text-fuchsia-700', dot: 'bg-fuchsia-500' },
  { value: 'profissional', label: 'Profissional', color: 'bg-slate-100 text-slate-700', dot: 'bg-slate-500' },
];

export const categoryLabel = value =>
  CONTENT_CATEGORIES.find(c => c.value === value)?.label || value || '';

export const categoryColor = value =>
  CONTENT_CATEGORIES.find(c => c.value === value)?.color || 'bg-n-slate-3 text-n-slate-11';

export const categoryDot = value =>
  CONTENT_CATEGORIES.find(c => c.value === value)?.dot || 'bg-slate-400';
